<ng-container [formGroup]="formGroup">
  <app-dropdown-image
    [options]="customColors$ | async"
    [imagePath]="'ortho-custom-colour/'"
    [formControlName]="colorBaseKey"
    [label]="'dental.attributes.graphic.choose_color' | translate"
    [styleClass]="'mb-2'">
  </app-dropdown-image>

  <app-dropdown-image
    [options]="customGraphics$ | async"
    [imagePath]="'ortho-custom-graphic/'"
    [formControlName]="graphicBaseKey"
    [label]="'dental.attributes.graphic.choose_graphic' | translate">
  </app-dropdown-image>
</ng-container>

<app-uploader
  [control]="formGroup?.get(fileAttributeKey)"
  [label]="'attributes.graphic.upload_graphic.label' | translateDental"
  [description]="'attributes.graphic.upload_graphic.description' | translateDental"
  [multiple]="false"
  [maxCount]="1"
  [fileableType]="'order-product'"
  [fileableId]="orderProductId"
  [tag]="'graphic2'"
  [extensionsAccepted]="['gif', 'png', 'jpg', 'jpeg', 'pdf', 'shd1']">
</app-uploader>
